/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type Imprint_viewer$ref: FragmentReference;
export type Imprint_viewer = {|
  +category: ?{|
    +name: string,
    +description: string,
  |},
  +$refType: Imprint_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "Imprint_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "category",
      "storageKey": "category(node:\"imprint\")",
      "args": [
        {
          "kind": "Literal",
          "name": "node",
          "value": "imprint",
          "type": "String"
        }
      ],
      "concreteType": "CategoryNode",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5421a548056fabd5007ce9a0dc42d633';
module.exports = node;
